module.exports = __webpack_public_path__ + "static/cloudkill-733dad581dbc7973decc00b2f93395e5.jpg";